import React from 'react';
import {Route, Switch} from 'react-router-dom';
import {
    AdminRoutes,
    LocaleAdminRoutes,
    GroupAdminRoutes,
    NotAuthenticatedRoutes, USER_HOME,
} from "./Routes";
import {inject, observer} from 'mobx-react';
import {State} from "../stores/AuthStore";
import {USER_TYPE} from "../stores/UserStore";

function RouteList(props) {
    const { loginState } = props.authStore;
    let routes = NotAuthenticatedRoutes;

    const userType = props.authStore.getUserType();
    const userHome = loginState === State.Authenticated ? USER_HOME[userType] : USER_HOME['None'];

    if (loginState === State.Authenticated) {
        if (props.authStore.loginUser) {
            const userType = props.authStore.getUserType();
            switch (userType) {
                case USER_TYPE.Admin:
                    routes = AdminRoutes;
                    break;
                case USER_TYPE.LocaleAdmin:
                    routes = LocaleAdminRoutes;
                    break;
                case USER_TYPE.GroupAdmin:
                    routes = GroupAdminRoutes;
                    break;
                default:
                    break;
            }
        }
    }

    return (
        <Switch>
            {
                routes.map((route, index) => (
                    <Route
                        exact
                        path={route.path}
                        component={route.component}
                        key={index}
                    />
                ))
            }
            <Route component={userHome.component} />
        </Switch>
    )
}

export default inject('authStore',)(observer(RouteList));
